<template>
  <Card :title="$t('common.Timer')">
    <CardSection>
      <BaseNodeProperties
        :node="node"
        :readonly="readonly"
      />
      <FormLayout>
        <Select
          :label="$t('common.Type')"
          :options="typeOptions"
          :value="type"
          :disabled="readonly"
          @change="setType"
        />
        <Select
          v-if="node.waitUntilAttribute"
          :label="$t('common.Date property')"
          :help-text="$t('help.timerDelay')"
          :options="datePropOptions"
          :disabled="readonly"
          v-model="node.waitUntilAttribute"
        />
        <Select
          :label="$t('common.Duration')"
          :placeholder="$t('common.Select a duration')"
          :options="durations"
          :value="absDuration"
          :disabled="readonly"
          @change="setDuration"
        />
        <TimezonePicker
          v-if="type === 'property'"
          :label="$t('common.Timezone')"
          :help-text="$t('help.timezoneDescription')"
          :disabled="readonly"
          v-model="node.timezone"
        />
        <Checkbox
          v-if="node.waitUntilAttribute"
          :label="$t('common.Negate duration from property time')"
          :help-text="$t('help.timerDuration')"
          :checked="node.waitForSeconds < 0"
          :disabled="readonly"
          @change="setNegation"
        />
        <Checkbox
          v-if="doc.isCancelableFlow"
          :label="$t('common.Continue flow on new session or order')"
          :help-text="$t('help.flow')"
          :disabled="readonly"
          v-model="node.preventFlowCancel"
        />
      </FormLayout>
    </CardSection>
  </Card>
</template>

<script>
import mixin from './propertiesMixin'
import UI from 'fanplayr-ui'

export default {
  mixins: [mixin],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    absDuration() {
      const value = this.node.waitForSeconds
      return value !== null
        ? Math.abs(value)
        : null
    },
    isNegated() {
      return this.node.waitForSeconds < 0
    },
    type() {
      return this.node.waitUntilAttribute
        ? 'property'
        : 'relative'
    },
    typeOptions() {
      return [
        {
          value: 'relative',
          label: this.$t('common.Relative to previous action')
        },
        {
          value: 'property',
          label: this.$t('common.Relative to custom data property'),
          disabled: !this.datePropOptions.length
        }
      ]
    },
    datePropOptions() {
      return this.account.customData
        .filter(d => d.type === 'date')
        .map(d => ({
          value: d.id,
          label: d.label || d.id
        }))
    },
    durations() {
      const mins = 60
      const hours = 60 * 60
      const days = 24 * 60 * 60
      const itemSeconds = [
        // minutes
        mins * 15,
        mins * 30,
        mins * 45,
        // hours
        hours * 1,
        hours * 2,
        hours * 3,
        hours * 6,
        hours * 12
      ]
      for (let i = 1; i <= 20; i++) {
        itemSeconds.push(days * i)
      }
      itemSeconds.push(days * 30)
      const items = itemSeconds.map(secs => {
        return {
          value: secs,
          label: UI.format(secs * 1000, 'durationMs')
        }
      })
      if (this.node.waitUntilAttribute) {
        items.unshift({
          value: 0,
          label: this.$t('common.No delay')
        })
      }
      return items
    }
  },
  created() {
    if (!this.node.timezone) {
      this.node.timezone = this.account.timezone
    }
  },
  methods: {
    setDuration(value) {
      this.node.waitForSeconds = value * (this.isNegated ? -1 : 1)
    },
    setType(type) {
      this.node.waitUntilAttribute = (type === 'property')
        ? this.datePropOptions[0].value
        : null
      this.node.waitForSeconds = null
    },
    setNegation(value) {
      const abs = this.absDuration
      this.node.waitForSeconds = value
        ? -abs
        : abs
    }
  }
}
</script>
